import { F5Logo } from '@platform/components';
import LumenLogo from '../dashboard/home/logos/lumen.png';
import TrustedbyLogos from '../home/trusted-by-logos.json';
import MicrosoftLogoSvg from './svgs/microsoft-logo.svg';

const getLogos = () => {
  const sap = TrustedbyLogos.find((l) => l.title === 'SAP');
  const ey = TrustedbyLogos.find((l) => l.title === 'EY');

  return [
    {
      key: 'SAP',
      src: sap ? `https:${sap.imgUrl}` : null,
      alt: 'SAP',
      isSvg: false,
      width: 116,
      height: 58,
    },
    {
      key: 'Microsoft',
      src: MicrosoftLogoSvg,
      alt: 'Microsoft',
      isSvg: false,
      width: 263,
      height: 56,
    },
    {
      key: 'EY',
      src: ey ? `https:${ey.imgUrl}` : null,
      alt: 'EY',
      isSvg: false,
      width: 67,
      height: 62,
    },
    { key: 'Lumen', src: LumenLogo, alt: 'Lumen', isSvg: false, width: 199, height: 61 },
    { key: 'F5', src: null, alt: 'F5', isSvg: true, width: 62, height: 62 },
  ];
};

export const PartnerLandingWhoYoullWorkWithSection = () => {
  const logos = getLogos();

  return (
    <section className='bg-white px-4 py-16 sm:px-8 sm:py-20'>
      <div className='mx-auto max-w-[1216px]'>
        <h2 className='mb-2 text-center text-3xl sm:text-4xl font-medium leading-11 tracking-[-0.72px] text-gray-600'>
          Who you&apos;ll work with
        </h2>
        <p className='mb-12 sm:mb-16 text-gray-500 text-center font-normal text-xl leading-7'>
          Skilled professionals from leading global companies
        </p>
        <div className='flex flex-col items-center gap-8 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-12 lg:gap-16'>
          {logos.map((logo) => (
            <div
              key={logo.key}
              className='flex min-w-[120px] items-center justify-center'
              style={{ height: logo.height }}
            >
              {logo.isSvg ?
                <div
                  className='flex items-center justify-center [&_svg]:h-full [&_svg]:w-full'
                  style={{ width: logo.width, height: logo.height }}
                >
                  <F5Logo />
                </div>
              : logo.src && (
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    width={logo.width}
                    height={logo.height}
                    className='object-contain'
                  />
                )
              }
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
